import { BoundingPoint } from './bounding-point';

export interface BoundingBox {
    min: BoundingPoint;
    max: BoundingPoint;
}
